import {
  Box,
  Button,
  Center,
  CircularProgress,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Input,
  InputGroup,
  Textarea,
} from '@chakra-ui/react';
import ContentLayout from 'components/layout/ContentLayout';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import {
  getDetailLayanan,
} from 'utils/axios.services';
const he = require('he');

export default function DetailLayananDietela() {
  const params = useParams();
  const layananId = params.layananId;
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const [data, setData] = useState({
    id: '',
    judul: '',
  });

  const {
    register,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      id: '',
      judul: '',
      isi: '',
      btnText: '',
      link: '',
    },
  });

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const { data: response } = await getDetailLayanan(layananId);

      setValue('id', response.data.id);
      setValue('judul', response.data.judul);
      setValue('isi', response.data.isi);
      setValue('btnText', response.data.btnText);
      setValue('link', he.decode(response.data.link));

      setData({
        id: response.data.id,
        judul: response.data.judul,
      });

      setIsLoading(false);
    }

    fetchData();
  }, [layananId, params.layananId, setValue]);

  async function handleEdit() {
    navigate(`/manajemen-layanan-dietela/edit/${data.id}`);
  }

  async function handleBack() {
    navigate('/manajemen-layanan-dietela');
  }

  const routes = [
    {
      name: 'Manajemen Layanan Dietela',
      url: '/manajemen-layanan-dietela',
    },
    {
      name: 'Detail',
    },
  ];

  return (
    <ContentLayout routes={routes}>
      <Heading fontSize="28" mb="8">
        Detail Layanan Dietela
      </Heading>
      {isLoading ? (
        <Center>
          <CircularProgress isIndeterminate color="dietela.primary" />
        </Center>
      ) : (
        <Box
          bgColor="white"
          borderRadius="1rem"
          p="5"
          w={{
            base: 'full',
            lg: '600px',
          }}
        >
          <Flex as="form" flexDirection="column" gap="6">
            <FormControl isInvalid={errors.judul} isRequired>
              <FormLabel>Judul</FormLabel>
              <InputGroup>
                <Input
                  isDisabled
                  id="judul"
                  placeholder={'Masukkan Judul'}
                  {...register('judul', {
                    required: 'Nama Depan wajib diisi',
                  })}
                  color="black"
                  fontFamily="roboto"
                  fontWeight="400px"
                  focusBorderColor="teal"
                />
              </InputGroup>
              <FormErrorMessage>
                {errors.judul && errors.judul.message}
              </FormErrorMessage>
            </FormControl>
            <FormControl isInvalid={errors.isi} isRequired>
              <FormLabel>Isi</FormLabel>
              <InputGroup>
                <Textarea
                  id="isi"
                  placeholder="Masukkan Isi"
                  {...register('isi', {
                    required: 'Field wajib diisi',
                  })}
                  isDisabled
                  color="black"
                  fontFamily="roboto"
                  fontWeight="400px"
                  focusBorderColor="teal"
                />
              </InputGroup>
              <FormErrorMessage>
                {errors.isi && errors.isi.message}
              </FormErrorMessage>
            </FormControl>
            <FormControl isInvalid={errors.link} isRequired>
              <FormLabel>Tulisan di button</FormLabel>
              <InputGroup>
                <Input
                  id="btnText"
                  type="text"
                  placeholder="Masukkan Tulisan Button"
                  {...register('btnText', {
                    required: 'Button text wajib diisi',
                  })}
                  isDisabled
                  color="black"
                  fontFamily="roboto"
                  fontWeight="400px"
                  focusBorderColor="teal"
                />
              </InputGroup>
              <FormErrorMessage>
                {errors.link && errors.link.message}
              </FormErrorMessage>
            </FormControl>
            <FormControl isInvalid={errors.link} isRequired>
              <FormLabel>Button Link</FormLabel>
              <InputGroup>
                <Input
                  id="link"
                  type="text"
                  placeholder="Masukkan Link"
                  {...register('link', {
                    required: 'Link wajib diisi',
                  })}
                  isDisabled
                  color="black"
                  fontFamily="roboto"
                  fontWeight="400px"
                  focusBorderColor="teal"
                />
              </InputGroup>
              <FormErrorMessage>
                {errors.link && errors.link.message}
              </FormErrorMessage>
            </FormControl>
            <Flex
              rowGap="3"
              columnGap="5"
              mt="3"
              alignItems="center"
              justifyContent="center"
            >
              <Button
                width={200}
                colorScheme="gray"
                borderRadius="full"
                py={6}
                onClick={() => handleBack()}
              >Kembali</Button>
              <Button
                width={200}
                colorScheme="teal"
                borderRadius="full"
                py={6}
                onClick={() => handleEdit()}
              >Edit</Button>
            </Flex>
          </Flex>
        </Box>
      )}
    </ContentLayout>
  );
}
